export default __webpack_public_path__ + "static/media/ColorEmployeeOnboardingIcon.c096a6b4.svg";